import { createFileRoute, redirect } from "@tanstack/react-router";
import { config } from "@/data/config";
import { redirectIfModuleDisabled } from "@/lib/module-guards";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_marketing/developers/webhooks")({
	beforeLoad: () => {
		redirectIfModuleDisabled("public_api", "/");
		throw redirect({
			to: "/docs/api-reference/$",
			params: { _splat: "guides/webhooks" },
		});
	},
	head: () =>
		seo({
			title: "Webhooks",
			description: `Webhook integration guide for ${config.siteName} — outbound events and verification patterns.`,
			keywords: "webhooks, event delivery, integrations",
		}),
});
